<template>
  <div class="input">
    <div class="input-label">タイムゾーン</div>
    <div class="input-group">
      <input-select
        :option="timezone"
        :options="timezones"
        @select="(o) => timezone = o.tzCode" />
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import MixinTimeZoneList from '@/components/MixinTimeZoneList'
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect,
    MixinTimeZoneList,
  },

  computed: {
    timezones : function () {
      return MixinTimeZoneList
    },

    timezone: {
      get: function () {
        let code = this.$store.state.event.timezone
        return MixinTimeZoneList.find(obj => obj.tzCode === code)
      },
      set: function (value) {
        this.$store.commit(
          'event/setTimeZone',
          value
        )
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
